import { getEffectiveStepStatus } from '../../../AutomationStudio/utils/stepExecutionDisplay';
import StepStatusChip from '../../../AutomationStudio/components/shared/StepStatusChip';

export default function StepExecutionStatusBadge({
    step,
    execDetail = null,
    statusOptions = null,
    instructions = null,
}) {
    const status = getEffectiveStepStatus(step, execDetail, instructions, statusOptions);
    return <StepStatusChip status={status} uppercase />;
}
